export default __webpack_public_path__ + "static/media/confetti-scholar_icon.36575c64.svg";